import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {AdtaDeviceOverviewContext} from "../context/AdtaDeviceOverviewContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"

const DeleteAdtaSorterConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);
    const {open, setOpen} = props;
    const [bayId, setBayId] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const stateValues = {
        bayId: bayId,
        mac: mac
    }

    const sorterConfigList = viewModel.sorterConfig[mac].map(({bayId}) => bayId);
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedOptions = sorterConfigList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const onClickConfirm = (stateValues) => {
        deleteData(stateValues);
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setBayId("");
    }

    const deleteData = (stateValues) => {
        dispatch({
            type: 'DELETE_DEVICE_CONFIG_DATA',
            data: {dispatcher: dispatch, mac: stateValues.mac, bayId: stateValues.bayId}
        })
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "device.delete_config_button_modal"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        <FormattedMessage id="modal.bayiddelete"
                                          defaultMessage="Please select the Bay Id you would like to remove:"/>
                    </Text>
                    <Select
                        value={bayId}
                        onChange={setBayId}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder="Select bay ID"
                        width={300}>
                        {matchedOptions.map((bayId) => (
                            <SelectOption key={bayId} value={bayId} label={bayId}/>
                        ))}
                        {!matchedOptions.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {sorterConfigList ? <Text alignment="center"> No matching bay IDs </Text>
                                    : <Text alignment="center"> No bay IDs available </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(stateValues)}>
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAdtaSorterConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/modal/DeleteAdtaSorterConfigurationModal.js